import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/joy';
import { Article, ClipboardText as Assignment, Flask as Science, Wrench as Engineering } from '@phosphor-icons/react';

export const DocsPage: React.FC = () => {
  const documentCategories = [
    {
      title: 'User Guides',
      icon: <Article />,
      description: 'Step-by-step guides for using ApexOS features',
      items: ['Getting Started', 'Job Management', 'Customer Relations', 'Billing & Invoicing']
    },
    {
      title: 'API Documentation',
      icon: <Engineering />,
      description: 'Technical documentation for developers',
      items: ['REST API Reference', 'Authentication', 'Webhooks', 'SDKs']
    },
    {
      title: 'Policies & Procedures',
      icon: <Assignment />,
      description: 'Company policies and operational procedures',
      items: ['Safety Guidelines', 'Quality Standards', 'Employee Handbook', 'Compliance']
    },
    {
      title: 'Training Materials',
      icon: <Science />,
      description: 'Training resources for team members',
      items: ['New Employee Onboarding', 'System Training', 'Best Practices', 'Troubleshooting']
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography level="h1" sx={{ mb: 3 }}>
        Documentation
      </Typography>
      
      <Typography level="body-lg" sx={{ mb: 4, color: 'text.secondary' }}>
        Access comprehensive documentation, guides, and resources for ApexOS.
      </Typography>

      <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
        {documentCategories.map((category, index) => (
          <Card key={index} variant="outlined">
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                {category.icon}
                <Typography level="h4" sx={{ ml: 1 }}>
                  {category.title}
                </Typography>
              </Box>
              
              <Typography level="body-md" sx={{ mb: 2, color: 'text.secondary' }}>
                {category.description}
              </Typography>
              
              <Box component="ul" sx={{ pl: 2, m: 0 }}>
                {category.items.map((item, itemIndex) => (
                  <Typography component="li" key={itemIndex} level="body-sm" sx={{ mb: 0.5 }}>
                    {item}
                  </Typography>
                ))}
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};